import axios from 'axios';

import { prepareInvoiceDetailsModel } from '~/domain/invoices/api/model/invoiceDetails';

export const setInvoiceAsCancelled = async (id: number) => {
  const response = await axios.post(`operators/invoices/${id}/cancel`);

  return prepareInvoiceDetailsModel(response.data);
};
